// GF-CUSTOM (ADR 0002) — keeps the Verfügbarkeitsstatus in step with the variant
// picker. snippets/delivery-status.liquid writes the status of every variant into
// data-gf-availability. The theme fires variant:changed after it has rewritten
// the add-to-cart button, so the status label set here wins. It only swaps
// Button--primary/--secondary, so the gf-status-button colour classes stay
// until this script replaces them.
(() => {
  const source = document.querySelector('script[data-gf-availability]');
  if (!source) {
    return;
  }

  const statuses = JSON.parse(source.textContent);
  const line = document.querySelector('[data-gf-availability-line] .tag');
  const reminder = document.querySelector('.gf-notify-button');

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail && event.detail.variant;
    const status = variant && statuses[variant.id];
    if (!status) {
      return;
    }

    if (line) {
      line.className = `tag ${status.tone}`;
      line.textContent = status.text;
    }

    if (reminder) {
      reminder.hidden = !status.reminder;
    }

    const button = event.target.querySelector('.ProductForm__AddToCart');
    if (button) {
      button.classList.remove('gf-status-button--unavailable', 'gf-status-button--soon');
      if (status.buttonTone) {
        button.classList.add(`gf-status-button--${status.buttonTone}`);
      }
    }
    if (button && status.label) {
      const caption = variant.available ? button.querySelector('span') : button;
      if (caption) {
        caption.textContent = status.label;
      }
    }

    const paymentButton = event.target.querySelector('.shopify-payment-button');
    if (paymentButton && status.code === 'pre_order') {
      paymentButton.style.display = 'none';
    }
  });
})();
